module.exports = __webpack_public_path__ + "img/1575af4.jpg";